import { ChainDoesNotSupportContract } from '../../errors/chain.js';
export function getChainContractAddress(_ref) {
  var _chain$contracts;
  let {
    blockNumber,
    chain,
    contract: name
  } = _ref;
  const contract = chain === null || chain === void 0 || (_chain$contracts = chain.contracts) === null || _chain$contracts === void 0 ? void 0 : _chain$contracts[name];
  if (!contract) throw new ChainDoesNotSupportContract({
    chain,
    contract: {
      name
    }
  });
  if (blockNumber && contract.blockCreated && contract.blockCreated > blockNumber) throw new ChainDoesNotSupportContract({
    blockNumber,
    chain,
    contract: {
      name,
      blockCreated: contract.blockCreated
    }
  });
  return contract.address;
}
//# sourceMappingURL=getChainContractAddress.js.map